module.exports = __webpack_public_path__ + "img/ic_delete.b1dc0dcc.svg";